import React, { Fragment } from 'react'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Head from 'next/head'

function Refund() {
  return (
    <Fragment>  
      <Head>
        <title>Clubr-Refund Policy</title>
        <meta name="description" content="Clubr-Refund Policy"></meta>
        <meta property="og:title" content="Clubr-Refund Policy<"></meta>
        <meta property="og:description" content="Clubr-Refund Policy"></meta>
        <meta property="og:image" content="https://clubrstorage.blob.core.windows.net/clubr-img/OGImageHome.jpg"></meta>
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Clubr" />
        <meta property="og:url" content={`https://clubr.in/refund`} />
      </Head>        
      <Container>
          <Typography component="div" sx={{
              minHeight: '100vh',
              pt: 8,
              pb: 5,
              color:"#979797"
            }}>
              <Typography variant="h4" sx={{mt:4, mb:1}}>Refund Policy</Typography>
            <Typography variant="h6" sx={{ mb: 0.25, color: '#ffffff' }}>Cancellation Rights and Refunds</Typography>
            <ol>
              <li>
                <Typography variant="body1" sx={{pb:'15px !important'}}>Tickets cannot be transferred, exchanged, or refunded once purchased other than for the reasons set out in our terms and conditions.</Typography>
              </li>
              <li>
                <Typography variant="body1" sx={{ pb: '15px !important' }}>No duplicate tickets will be issued to replace tickets that have been lost or stolen after they have been delivered to you, and nor will such tickets be refunded.</Typography>
              </li>
            </ol>            
              
            <Typography variant="h6" sx={{ mb: 0.25, color: '#ffffff' }}>Refunds</Typography>
              <ol>
                <li>
                    <Typography variant="body1" sx={{pb:'15px !important'}}>If the event is postponed, the purchased ticket will be considered valid for the substitute event in the same or nearby location.</Typography>
                </li>
                <li>
                    <Typography variant="body1" sx={{pb:'15px !important'}}>In case of event cancellation, meaning that no alternative events are offered by the Promoter, you will be eligible for a refund. For refund process please contact us via mail: tickets@clubr.in</Typography>
                </li>
                <li>
                    <Typography variant="body1" sx={{pb:'15px !important'}}>If for any reason you are entitled to a refund, in most cases you must return any tickets you have: follow the refund instructions otherwise you may not receive a refund. If these require you to return the tickets, do so promptly and within the timeframe communicated to you.</Typography>
                </li>
                <li>
                    <Typography variant="body1" sx={{pb:'15px !important'}}>Any refund will usually be paid, using the same method you used to buy the tickets, within 90 days of the date that we receive your returned tickets, whichever is later.</Typography>
                </li>
                <li>
                    <Typography variant="body1" sx={{pb:'15px !important'}}>For more information about refunds, please contact us.</Typography>
                </li>
                <li>
                  <Typography variant="body1" sx={{ pb: '15px !important' }}>No refunds will be offered under any circumstances if you fail to comply with the all terms and conditions applicable to those tickets or the event.</Typography>
                </li>
              </ol>
        </Typography>
      </Container>
    </Fragment>
  )
}

export default Refund